import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export function RequireHeartSelected({ children }) {
  const tempHeart = useSelector((state) => state.heart.tempHeart);

  if (!tempHeart?.id) {
    return <Navigate to="/add-heart" replace />;
  }

  return children;
}
